import React, { useEffect } from "react";
import { getUserprofileAction } from "../../store/auth/authActions";
import { authActions } from "../../store/auth";
import { useDispatch } from "react-redux";
import store from "store";
import { useNavigate } from "react-router-dom";

const GetUserProfile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = store.get("authToken");

  useEffect(() => {
    if (token !== undefined) {
      getUserprofileAction(token, navigate)(dispatch);
      dispatch(authActions.setToken({ token }));
    }
  }, [dispatch, navigate, token]);

  return <div></div>;
};

export default GetUserProfile;
